import { render, staticRenderFns } from "./pay-tax.vue?vue&type=template&id=8265bc68&"
import script from "./pay-tax.vue?vue&type=script&lang=js&"
export * from "./pay-tax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8265bc68')) {
      api.createRecord('8265bc68', component.options)
    } else {
      api.reload('8265bc68', component.options)
    }
    module.hot.accept("./pay-tax.vue?vue&type=template&id=8265bc68&", function () {
      api.rerender('8265bc68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/pay-tax.vue"
export default component.exports